import type { RouteRecordRaw } from "vue-router";
import { crudRoutes } from "src/router/crud-routes";
import OrganisationView from "src/views/OrganisationView.vue";
import UnitView from "src/views/UnitView.vue";

/**
 * Entities that use a custom view instead of the generic CrudView.
 * The generated route metadata (table columns, filters, requests) is preserved —
 * only the component is swapped.
 */
const componentOverrides: Record<string, RouteRecordRaw["component"]> = {
  organisations: OrganisationView,
  units: UnitView,
};

const overriddenNames = new Set(Object.keys(componentOverrides));

const overriddenRoutes = Object.entries(componentOverrides).map(
  ([name, component]) => {
    const generated = crudRoutes.find((r) => r.name === name);
    if (!generated) {
      throw new Error(`Custom CRUD override references unknown route "${name}"`);
    }
    return { ...generated, component } as RouteRecordRaw;
  },
);

export const customCrudRoutes: RouteRecordRaw[] = [
  ...crudRoutes.filter((r) => !overriddenNames.has(r.name as string)),
  ...overriddenRoutes,
];
